import React from 'react';

function Corporate() {
  return (
    <div>
      <svg
        width='80'
        height='80'
        viewBox='0 0 80 80'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_115_362)'>
          <rect width='80' height='80' rx='40' fill='currentColor' />
          <path
            d='M37.0886 23.635C37.5686 23.3896 38.1002 23.2616 38.6395 23.2616C39.1789 23.2616 39.7105 23.3896 40.1905 23.635L52.6614 30.0067C53.2403 30.3029 53.7219 30.7586 54.0491 31.3196L38.6423 39.4106L23.2599 31.2671C23.5868 30.7292 24.0572 30.2925 24.6186 30.0058L37.0886 23.635ZM22.7674 33.5681L38.108 41.688C38.2711 41.7743 38.4529 41.8196 38.6375 41.8199C38.8221 41.8202 39.004 41.7756 39.1674 41.6898L42.9867 39.6847C43.4311 38.9519 44.0575 38.346 44.8054 37.9254C45.5533 37.5049 46.3973 37.284 47.2558 37.2842H47.5587L54.5116 33.6333V38.0895C55.1436 38.4997 55.6741 39.0474 56.0634 39.6915C56.4527 40.3356 56.6905 41.0593 56.7591 41.8083H56.7791V33.027C56.7791 31.9861 56.4911 30.9653 55.9468 30.0772C55.4026 29.189 54.6232 28.468 53.6944 27.9935L41.2235 21.6217C40.4238 21.2131 39.5381 21 38.6395 21C37.741 21 36.8553 21.2131 36.0556 21.6217L23.5846 27.9935C22.6559 28.468 21.8765 29.189 21.3322 30.0772C20.788 30.9653 20.5 31.9861 20.5 33.027V47.9159C20.5 49.4157 21.0972 50.8542 22.1603 51.9147C23.2234 52.9752 24.6652 53.5711 26.1686 53.5711H37.7326V51.309H26.1686C25.2666 51.309 24.4015 50.9515 23.7636 50.3152C23.1258 49.6789 22.7674 48.8158 22.7674 47.9159V33.5681ZM44.0814 42.2608V43.618H42.2674C41.5458 43.618 40.8537 43.904 40.3435 44.413C39.8332 44.9221 39.5465 45.6125 39.5465 46.3325V56.2855C39.5465 57.0055 39.8332 57.6959 40.3435 58.2049C40.8537 58.714 41.5458 59 42.2674 59H56.7791C57.5007 59 58.1928 58.714 58.7031 58.2049C59.2133 57.6959 59.5 57.0055 59.5 56.2855V46.3325C59.5 45.6125 59.2133 44.9221 58.7031 44.413C58.1928 43.904 57.5007 43.618 56.7791 43.618H54.9651V42.2608C54.9651 41.4208 54.6307 40.6153 54.0354 40.0214C53.44 39.4275 52.6326 39.0939 51.7907 39.0939H47.2558C46.4139 39.0939 45.6065 39.4275 45.0112 40.0214C44.4158 40.6153 44.0814 41.4208 44.0814 42.2608ZM47.2558 40.9035H51.7907C52.1515 40.9035 52.4976 41.0465 52.7527 41.301C53.0078 41.5556 53.1512 41.9008 53.1512 42.2608V43.618H45.8953V42.2608C45.8953 41.9008 46.0387 41.5556 46.2938 41.301C46.549 41.0465 46.895 40.9035 47.2558 40.9035Z'
            fill='#FEFEFE'
          />
        </g>
        <defs>
          <filter
            id='filter0_i_115_362'
            x='-4.42632'
            y='-0.737721'
            width='84.4263'
            height='80.7377'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='-4.42632' dy='-0.737721' />
            <feGaussianBlur stdDeviation='2.21316' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_115_362'
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
}

export default Corporate;
